module.exports = __webpack_public_path__ + "img/default.1f404b9a.png";